import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "float-control-panel"
}
const _hoisted_2 = { class: "float-control-item-icon" }
const _hoisted_3 = { class: "float-control-item-icon" }
const _hoisted_4 = { class: "float-control-item-icon" }

import { profile, status, isMinimized } from "../store";
import { STATUS } from "../constants";
import { TUICallKitServer } from "../index";
import FloatCallEnd from "../icons/floatCallEnd.vue";
import FloatMicrophoneSVG from "../icons/floatMicrophone.vue";
import FloatMicrophoneClosedSVG from "../icons/floatMicrophoneClosed.vue";
import FloatFullScreenSVG from "../icons/floatFullScreen.vue";
import "../style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'TUICallKitMini',
  setup(__props) {

function toggleMinimize() {
  TUICallKitServer.toggleMinimize();
}

const hangup = () => {
  TUICallKitServer.hangup();
};

const toggleMicrophone = async () => {
  if (profile.value?.microphone) {
    await TUICallKitServer.closeMicrophone();
  } else {
    await TUICallKitServer.openMicrophone();
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(status) !== _unref(STATUS).IDLE)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "float-control-item-icon-container",
            onClick: hangup
          }, [
            _createVNode(FloatCallEnd)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "float-control-item-icon-container",
            onClick: toggleMicrophone
          }, [
            (_unref(profile)?.microphone)
              ? (_openBlock(), _createBlock(FloatMicrophoneSVG, { key: 0 }))
              : _createCommentVNode("", true),
            (!_unref(profile)?.microphone)
              ? (_openBlock(), _createBlock(FloatMicrophoneClosedSVG, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "float-control-item-icon-container",
            onClick: toggleMinimize
          }, [
            _createVNode(FloatFullScreenSVG)
          ])
        ])
      ], 512)), [
        [_vShow, _unref(isMinimized)]
      ])
    : _createCommentVNode("", true)
}
}

})